module.exports = __webpack_public_path__ + "fonts/Graphik-Semibold.7ef1e78.otf";